export default __webpack_public_path__ + "static/media/ab3.e022d90b.jpg";